import { generateReactHelpers } from "@uploadthing/react";
import type { OurFileRouter } from "@/app/api/uploadthing/core"; // ← adjust path to match your router

export const { useUploadThing, uploadFiles } =
  generateReactHelpers<OurFileRouter>();
